module.exports = __webpack_public_path__ + "img/2001.cd4dce91.jpg";